// extracted by mini-css-extract-plugin
export default {"container":"wS3TS2","item":"tUEAAD","icon":"DmH99j"};